import React, { useState, useEffect } from 'react';
import { collection, getDocs, doc, setDoc, updateDoc, deleteDoc } from 'firebase/firestore';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { db, auth } from '../firebase';

const ROLES = [
  { value:'admin', label:'Administrador', desc:'Ve todo, crea usuarios, edita y elimina cualquier caso', color:'#1d4ed8', bg:'#eff6ff' },
  { value:'tecnico', label:'Técnico', desc:'Ve todos los casos, registra y da seguimiento', color:'#15803d', bg:'#f0fdf4' },
  { value:'secretaria', label:'Secretaria', desc:'Ve todos los casos pero solo puede registrar casos nuevos', color:'#b45309', bg:'#fffbeb' },
];

function RolBadge({ rol }) {
  const r = ROLES.find(x=>x.value===rol)||ROLES[1];
  return <span style={{ background:r.bg, color:r.color, padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:700 }}>{r.label}</span>;
}

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ email:'', password:'', nombre:'', rol:'tecnico' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [editandoRol, setEditandoRol] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);

  async function cargar() {
    setLoading(true);
    const snap = await getDocs(collection(db,'usuarios'));
    setUsuarios(snap.docs.map(d=>({id:d.id,...d.data()})));
    setLoading(false);
  }
  useEffect(()=>{ cargar(); },[]);

  async function crearUsuario(e) {
    e.preventDefault();
    if (!form.email||!form.password||!form.nombre){setError('Completa todos los campos.');return;}
    if (form.password.length<6){setError('La contraseña debe tener mínimo 6 caracteres.');return;}
    setSaving(true); setError(''); setSuccess('');
    try {
      const cred = await createUserWithEmailAndPassword(auth,form.email,form.password);
      await setDoc(doc(db,'usuarios',cred.user.uid),{ email:form.email, nombre:form.nombre, rol:form.rol, creadoEn:new Date().toISOString() });
      setSuccess(`Usuario "${form.nombre}" creado correctamente.`);
      setForm({email:'',password:'',nombre:'',rol:'tecnico'});
      cargar();
    } catch(err) {
      if(err.code==='auth/email-already-in-use')setError('Este correo ya está registrado.');
      else if(err.code==='auth/invalid-email')setError('El correo no es válido.');
      else setError(err.message);
    }
    setSaving(false);
  }

  async function cambiarRol(uid,rol) {
    try { await updateDoc(doc(db,'usuarios',uid),{rol}); setUsuarios(p=>p.map(u=>u.id===uid?{...u,rol}:u)); setEditandoRol(null); }
    catch { alert('Error al cambiar el rol.'); }
  }

  async function eliminar(uid) {
    try { await deleteDoc(doc(db,'usuarios',uid)); setUsuarios(p=>p.filter(u=>u.id!==uid)); setConfirmDelete(null); }
    catch { alert('Error al eliminar el usuario.'); }
  }

  return (
    <div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10, marginBottom:20 }}>
        {ROLES.map(r=><div key={r.value} style={{ background:r.bg, border:`1.5px solid ${r.color}30`, borderRadius:10, padding:'12px 14px' }}><div style={{ fontSize:12, fontWeight:700, color:r.color, marginBottom:4 }}>{r.label}</div><div style={{ fontSize:11.5, color:r.color, opacity:.85, lineHeight:1.5 }}>{r.desc}</div></div>)}
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'360px 1fr', gap:20, alignItems:'start' }}>
        <div className="card">
          <div className="card-header"><h3>Crear nuevo usuario</h3></div>
          <div className="card-body">
            {error&&<div style={{ background:'var(--red-light)',border:'1px solid #fca5a5',borderRadius:8,padding:'9px 12px',fontSize:13,color:'var(--red)',marginBottom:14 }}>{error}</div>}
            {success&&<div style={{ background:'#f0fdf4',border:'1px solid #86efac',borderRadius:8,padding:'9px 12px',fontSize:13,color:'#15803d',marginBottom:14,fontWeight:500 }}>✓ {success}</div>}
            <form onSubmit={crearUsuario}>
              <div className="form-group"><label>Nombre completo</label><input value={form.nombre} onChange={e=>setForm(f=>({...f,nombre:e.target.value}))} placeholder="Nombre del usuario"/></div>
              <div className="form-group"><label>Correo electrónico</label><input type="email" value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} placeholder="usuario@correo.com"/></div>
              <div className="form-group"><label>Contraseña inicial</label><input type="password" value={form.password} onChange={e=>setForm(f=>({...f,password:e.target.value}))} placeholder="Mínimo 6 caracteres"/></div>
              <div className="form-group"><label>Rol</label>
                <select value={form.rol} onChange={e=>setForm(f=>({...f,rol:e.target.value}))}>
                  {ROLES.map(r=><option key={r.value} value={r.value}>{r.label}</option>)}
                </select>
              </div>
              <button type="submit" className="btn btn-primary" disabled={saving} style={{ width:'100%', justifyContent:'center' }}>{saving?'Creando...':'Crear usuario'}</button>
            </form>
          </div>
        </div>
        <div className="card">
          <div className="card-header"><h3>Usuarios registrados ({usuarios.length})</h3></div>
          <div className="table-wrap">
            <table>
              <thead><tr><th>Nombre</th><th>Correo</th><th>Rol</th><th>Acciones</th></tr></thead>
              <tbody>
                {loading?<tr><td colSpan={4} style={{ textAlign:'center',padding:24,color:'var(--gray-400)' }}>Cargando...</td></tr>:
                  usuarios.map(u=>(
                    <tr key={u.id}>
                      <td><div style={{ fontWeight:600, fontSize:13 }}>{u.nombre||'—'}</div></td>
                      <td style={{ fontSize:12, color:'var(--gray-500)' }}>{u.email}</td>
                      <td>
                        {editandoRol===u.id ? (
                          <div style={{ display:'flex', gap:5, flexWrap:'wrap' }}>
                            {ROLES.map(r=><button key={r.value} onClick={()=>cambiarRol(u.id,r.value)} style={{ background:u.rol===r.value?r.bg:'#f9fafb',color:r.color,border:`1.5px solid ${r.color}40`,borderRadius:6,padding:'3px 10px',fontSize:11,fontWeight:700,cursor:'pointer',fontFamily:'inherit' }}>{r.label}</button>)}
                            <button onClick={()=>setEditandoRol(null)} style={{ background:'none',border:'1px solid var(--gray-200)',borderRadius:6,padding:'3px 8px',fontSize:11,cursor:'pointer',fontFamily:'inherit' }}>✕</button>
                          </div>
                        ):(
                          <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                            <RolBadge rol={u.rol}/>
                            <button onClick={()=>setEditandoRol(u.id)} style={{ background:'none',border:'none',cursor:'pointer',color:'var(--gray-400)',padding:2,fontSize:13 }}>✏️</button>
                          </div>
                        )}
                      </td>
                      <td>
                        {confirmDelete===u.id?(
                          <div style={{ display:'flex', gap:5, alignItems:'center' }}>
                            <span style={{ fontSize:11, color:'var(--red)' }}>¿Eliminar?</span>
                            <button onClick={()=>eliminar(u.id)} style={{ background:'var(--red)',color:'#fff',border:'none',borderRadius:5,padding:'3px 8px',fontSize:11,cursor:'pointer',fontFamily:'inherit',fontWeight:700 }}>Sí</button>
                            <button onClick={()=>setConfirmDelete(null)} style={{ background:'none',border:'1px solid var(--gray-200)',borderRadius:5,padding:'3px 8px',fontSize:11,cursor:'pointer',fontFamily:'inherit' }}>No</button>
                          </div>
                        ):(
                          <button onClick={()=>setConfirmDelete(u.id)} style={{ background:'var(--red-light)',color:'var(--red)',border:'1px solid #fca5a5',borderRadius:6,padding:'4px 10px',fontSize:11,cursor:'pointer',fontFamily:'inherit',fontWeight:600 }}>Eliminar</button>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
